module.exports = __webpack_public_path__ + "img/icon4.4e65b16b.png";